import _classCallCheck from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Breakpoints } from '../helpers';
export var BreakpointWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BreakpointWrapper, _React$Component);

  function BreakpointWrapper(props) {
    var _this;

    _classCallCheck(this, BreakpointWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BreakpointWrapper).call(this, props));

    _this.handleMatchMedia = function (event) {
      _this.setState({
        isVisible: event.matches
      });
    };

    var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max,
        ssrBreakpoint = _this$props.ssrBreakpoint;

    if (min === Breakpoints.default) {
      min = undefined;
    }

    if (max === Breakpoints.default) {
      max = undefined;
    }

    if (ssrBreakpoint === Breakpoints.default) {
      ssrBreakpoint = undefined;
    }

    var mediaQueryMin = min ? " and (min-width: ".concat(min, "px)") : '';
    var mediaQueryMax = max ? " and (max-width: ".concat(max - 1, "px)") : '';
    _this.mediaQuery = "all".concat(mediaQueryMin).concat(mediaQueryMax);
    var isVisible = false;

    if (min && max && ssrBreakpoint) {
      isVisible = min <= ssrBreakpoint && max > ssrBreakpoint;
    } else if (min && ssrBreakpoint) {
      isVisible = min <= ssrBreakpoint;
    } else if (max && ssrBreakpoint) {
      isVisible = max > ssrBreakpoint;
    } else if (ssrBreakpoint) {
      isVisible = true;
    } else if (!min) {
      isVisible = true;
    }

    _this.state = {
      isVisible: isVisible
    };
    return _this;
  }

  _createClass(BreakpointWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mediaQueryList = window.matchMedia(this.mediaQuery);
      this.setState({
        isVisible: this.mediaQueryList.matches
      });

      if (!this.mediaQueryList.addEventListener) {
        // Fallback for Safari
        this.mediaQueryList.addListener(this.handleMatchMedia);
        return;
      }

      this.mediaQueryList.addEventListener('change', this.handleMatchMedia);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mediaQueryList) {
        if (this.mediaQueryList.removeEventListener) {
          this.mediaQueryList.removeEventListener('change', this.handleMatchMedia);
        } else {
          // Fallback for Safari
          this.mediaQueryList.removeListener(this.handleMatchMedia);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isVisible = this.state.isVisible;
      return isVisible && React.createElement(React.Fragment, null, children) || null;
    }
  }]);

  return BreakpointWrapper;
}(React.Component);